import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ConfirmationService } from 'tn-custom-primeng/api';
import { ScheduleJobService } from 'tnx-admin-service/schedulejob/services';
import { TriggerConstants, TriggerMethodType } from 'tnx-admin-service/scheduletrigger/constants';
import { ScheduleTriggerService } from 'tnx-admin-service/scheduletrigger/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'scheduletrigger',
    templateUrl: './scheduletrigger.component.html',
    styleUrls: ['./scheduletrigger.component.scss'],
    providers: [ComponentContextService],
})
export class ScheduleTriggerComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _scheduleTriggerService: ScheduleTriggerService,
        protected _scheduleJobService: ScheduleJobService,
        private _confirmService: ConfirmationService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.columnSetting.groupField = 'stridJob';
        this.setting.baseService = this._scheduleTriggerService;
        this.setting.objectName = 'lịch trình';
        this.setting.popupSize.height = 510;
        this.setting.modelSchemas = [
            new ModelSchema({
                field: 'cronText',
                name: 'Chuỗi Cron Trigger',
                fullName: 'Chuỗi Cron Trigger',
                description: 'Chuỗi Cron Trigger',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'idJob',
                name: 'Công việc',
                fullName: 'Công việc: Xác định Lịch trình của công việc nào. 1 Công việc có nhiều Lịch trình',
                description: 'Công việc: Xác định Lịch trình của công việc nào. 1 Công việc có nhiều Lịch trình',
            }),
            new ModelSchema({
                field: 'intervalCount',
                name: 'Số lần chạy',
                fullName: 'Số lần chạy',
                description: 'Số lần chạy',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'intervalHour',
                name: 'Lặp giờ',
                fullName: 'Lặp giờ',
                description: 'Lặp giờ',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'intervalMinute',
                name: 'Lặp phút',
                fullName: 'Lặp phút',
                description: 'Lặp phút',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'intervalSecond',
                name: 'Lặp giây',
                fullName: 'Lặp giây',
                description: 'Lặp giây',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'name',
                name: 'Tên lịch trình',
                fullName: 'Tên lịch trình',
                description: 'Tên lịch trình',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'startDate',
                name: 'Ngày bắt đầu',
                fullName: 'Ngày bắt đầu',
                description: 'Ngày bắt đầu',
                dataType: 'datetime',
            }),
            new ModelSchema({
                field: 'endDate',
                name: 'Ngày kết thúc',
                fullName: 'Ngày kết thúc',
                description: 'Ngày kết thúc',
                dataType: 'datetime',
            }),
            new ModelSchema({
                field: 'status',
                name: 'Trạng thái',
                fullName: 'Trạng thái lịch trình: Stop, Start, Pause, Resume',
                description: 'Trạng thái lịch trình: Stop, Start, Pause, Resume',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'type',
                name: 'Kiểu lịch trình',
                fullName: 'Kiểu lịch trình - False: SimpleTrigger, True: CronTrigger',
                description: 'Kiểu lịch trình - False: SimpleTrigger, True: CronTrigger',
                dataType: 'boolean'
            }),
            new ModelSchema({
                field: 'created',
                name: 'Thời gian tạo',
                fullName: 'Thời gian tạo',
                description: 'Thời gian tạo',
                dataType: 'datetime',
            }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'idJob',
                baseService: this._scheduleJobService,
                displayField: 'name',
                valueField: 'id'
            }),
            new ColumnSchemaBase({
                field: 'name',
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'type',
                dataSource: TriggerConstants.TriggerTypeDataSource,
                displayField: 'label',
                valueField: 'value'
            }),
            new ColumnSchemaBase({ field: 'intervalCount' }),
            new ColumnSchemaBase({ field: 'intervalHour' }),
            new ColumnSchemaBase({ field: 'intervalMinute' }),
            new ColumnSchemaBase({ field: 'intervalSecond' }),
            new ColumnSchemaBase({ field: 'cronText' }),
            new ColumnSchemaBase({
                field: 'startDate',
                format: 'normal'
            }),
            new ColumnSchemaBase({
                field: 'endDate',
                format: 'normal'
            }),
            new ColumnSchemaBase({
                field: 'created',
                format: 'normal'
            }),
            new ColumnSchemaBase({
                field: 'status',
                dataType: 'status',
                dataTypeRefField: 'status',
                dataSource: this.getShouldTriggerMethodTypeDataSource(true),
                displayField: 'labelStatus',
                valueField: 'value'
            }),
        ];
        super.ngOnInit();
    }

    getShouldTriggerMethodTypeDataSource(all: boolean) {
        return all ? TriggerConstants.TriggerMethodTypeDataSource : TriggerConstants.TriggerMethodTypeDataSource.filter(o => o.value == TriggerMethodType.Start || o.value == TriggerMethodType.Stop);
    }
    //#region Check Disabled Model

    isDisabledStart(data: any) {
        return this.isDisabled(data, TriggerMethodType.Start);
    }

    isDisabledPause(data: any) {
        return this.isDisabled(data, TriggerMethodType.Pause);
    }

    isDisabledStop(data: any) {
        return this.isDisabled(data, TriggerMethodType.Stop);
    }

    isDisabledResume(data: any) {
        return this.isDisabled(data, TriggerMethodType.Resume);
    }

    isDisabled(data: any, currentStatus: number) {
        const status = data.status;
        const hidden = new Array();

        switch (status) {
            case TriggerMethodType.Start:
            case TriggerMethodType.Resume:
                hidden.push(TriggerMethodType.Start, TriggerMethodType.Resume);
                break;
            case TriggerMethodType.Stop:
                hidden.push(TriggerMethodType.Stop, TriggerMethodType.Pause, TriggerMethodType.Resume);
                break;
            case TriggerMethodType.Pause:
                hidden.push(TriggerMethodType.Pause);
                break;
            default: break;
        }

        return hidden.includes(currentStatus);
    }

    //#endregion

    //#region Handle Change Trigger

    async changeTrigger_Start(data: any) {
        await this.changeTrigger(data, TriggerMethodType.Start);
    }

    async changeTrigger_Pause(data: any) {
        await this.changeTrigger(data, TriggerMethodType.Pause);
    }

    async changeTrigger_Stop(data: any) {
        await this.changeTrigger(data, TriggerMethodType.Stop);
    }

    async changeTrigger(data: any, currentStatus: number) {
        const status = data.status;
        currentStatus = currentStatus == TriggerMethodType.Start && status == TriggerMethodType.Pause ? TriggerMethodType.Resume : currentStatus;
        const confirmStatus = TriggerConstants.TriggerMethodTypeDataSource
            .filter(o => o.value == currentStatus)
            .pop();

        this._confirmService.confirm({
            acceptLabel: this._translateService.instant('CONFIRM.ACCEPT_LABEL'),
            rejectLabel: this._translateService.instant('CONFIRM.REJECT_LABEL'),
            message: confirmStatus.confirmMessage,
            header: confirmStatus.confirmHeader,
            accept: async () => {
                await this._scheduleTriggerService.changeTriggerStatus(data.id, currentStatus)
                    .then(rs => {
                        if (!rs.success) {
                            this._notifierService.showError(rs.console.error);
                            return;
                        }

                        this._notifierService.showSuccess(rs.message);
                    }).catch(err => {
                        this._notifierService.showWarning('Thao tác thất bại! Xin vui lòng thử lại sau');
                    });
                this.reload();
            }
        });
    }

    //#endregion Handle Change Job

    async afterGetData(): Promise<void> {
        for (const item of this.model.dataSource) {
            item.classStatus = TriggerConstants.TriggerMethodTypeDataSource
                .filter(o => o.value == item.status)
                .map(o => o.styleClass).pop();
        }
        // console.table(this.model.dataSource);
    }
}
